<template>
	<div class="admindashboard">
		<header>
			<h2>Panel admina</h2>
		</header>
		<PartnerList />
	</div>
</template>

<script>
import * as R from 'ramda';
import AppDataMixin from '@/mixins/app-data';
import PartnerList from './PartnerList';

export default {
	name: 'AdminDashboard',
	components: {PartnerList},
	mixins: [AppDataMixin],
};
</script>
